import type { AdminPickerCompanyDto } from '@carcheck/shared';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { tokens } from '../../../design';

/**
 * The picker's company (list column + drawer): the name and a role chip
 * («владелец» / «сотрудник»); «—» for a solo picker.
 */
export const PickerCompany = ({
  company,
  testId,
}: {
  company: AdminPickerCompanyDto | null;
  /** `data-testid` on the root (e2e hooks). */
  testId?: string;
}): ReactElement => {
  const { t } = useTranslation();
  if (company === null) {
    return (
      <Typography variant="body2" sx={{ color: tokens.text.tertiary }} data-testid={testId}>
        {t('pickers.noValue')}
      </Typography>
    );
  }
  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0, height: '100%' }}
      data-testid={testId}
    >
      <Typography variant="body2" noWrap title={company.name}>
        {company.name}
      </Typography>
      <Chip
        size="small"
        variant="outlined"
        color={company.role === 'owner' ? 'primary' : 'default'}
        label={t(`pickers.companyRole.${company.role}`)}
      />
    </Box>
  );
};
